<template>
  <b-card>
    <b-form class="mt-2">
      <b-row>
        <b-col cols="12" v-html="stripe_card"/>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      stripe_card: '<stripe-pricing-table pricing-table-id="prctbl_1M7luQL4SguAQeMIOeTMIJ2D"\n' +
        '                            publishable-key="pk_live_51LNNpOL4SguAQeMIn6Zip1OseqIei09wzAwg4pXC7ZzEJytsJzoTb0vnUIEqQO6Szsdcm03k3eBbrfomsJYjTP1J00vRlv2NKw">\n' +
        '      </stripe-pricing-table>'
    }
  }
}
</script>
